var map = {
	"./btn-1.png": "67aa",
	"./btn-2.png": "0834",
	"./btn-3.png": "cbec",
	"./btn-4.png": "e7e2",
	"./btn-5.png": "a28d",
	"./btn-6.png": "c8db"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ebc6";